/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiUserEtcResponse,
    ApiUserEtcResponseFromJSON,
    ApiUserEtcResponseFromJSONTyped,
    ApiUserEtcResponseToJSON,
} from './ApiUserEtcResponse';
import {
    Role,
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './Role';

/**
 * 
 * @export
 * @interface ApiUserResponse
 */
export interface ApiUserResponse {
    /**
     * 
     * @type {string}
     * @memberof ApiUserResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUserResponse
     */
    apiKey: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUserResponse
     */
    description: string | null;
    /**
     * 
     * @type {Array<Role>}
     * @memberof ApiUserResponse
     */
    roles: Array<Role> | null;
    /**
     * 
     * @type {Date}
     * @memberof ApiUserResponse
     */
    lastAuthenticatedAt: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiUserResponse
     */
    isLocked: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiUserResponse
     */
    isAuthenticationLocked: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ApiUserResponse
     */
    createdBy: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApiUserResponse
     */
    createdAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ApiUserResponse
     */
    modifiedBy: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApiUserResponse
     */
    modifiedAt: Date | null;
    /**
     * 
     * @type {ApiUserEtcResponse}
     * @memberof ApiUserResponse
     */
    etc: ApiUserEtcResponse | null;
}

export function ApiUserResponseFromJSON(json: any): ApiUserResponse {
    return ApiUserResponseFromJSONTyped(json, false);
}

export function ApiUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'apiKey': json['apiKey'],
        'description': json['description'],
        'roles': (json['roles'] === null ? null : (json['roles'] as Array<any>).map(RoleFromJSON)),
        'lastAuthenticatedAt': (json['lastAuthenticatedAt'] === null ? null : new Date(json['lastAuthenticatedAt'])),
        'isLocked': json['isLocked'],
        'isAuthenticationLocked': json['isAuthenticationLocked'],
        'createdBy': json['createdBy'],
        'createdAt': (json['createdAt'] === null ? null : new Date(json['createdAt'])),
        'modifiedBy': json['modifiedBy'],
        'modifiedAt': (json['modifiedAt'] === null ? null : new Date(json['modifiedAt'])),
        'etc': ApiUserEtcResponseFromJSON(json['etc']),
    };
}

export function ApiUserResponseToJSON(value?: ApiUserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'apiKey': value.apiKey,
        'description': value.description,
        'roles': (value.roles === null ? null : (value.roles as Array<any>).map(RoleToJSON)),
        'lastAuthenticatedAt': (value.lastAuthenticatedAt === null ? null : value.lastAuthenticatedAt.toISOString()),
        'isLocked': value.isLocked,
        'isAuthenticationLocked': value.isAuthenticationLocked,
        'createdBy': value.createdBy,
        'createdAt': (value.createdAt === null ? null : value.createdAt.toISOString()),
        'modifiedBy': value.modifiedBy,
        'modifiedAt': (value.modifiedAt === null ? null : value.modifiedAt.toISOString()),
        'etc': ApiUserEtcResponseToJSON(value.etc),
    };
}

